export default {
    getBadgeType(status) {
        const statusMap = {
            Active: 'success',
            Pending: 'warning',
            Canceled: 'danger',
        };

        return `badge-${statusMap[status]}`;
    },
};
